import { extendTailwindMerge } from "tailwind-merge";

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      shadow: [
        "shadow-circle",
        "shadow-circle2",
        "shadow-inner",
        "shadow-inner-right",
        "shadow-inner-thin",
        "shadow-dialog",
        "shadow-inner-2",
      ],
      "font-size": ["text-parent", "text-inherit"],
      // @ts-ignore
      "text-shadow": ["text-shadow-lg", "text-shadow"],
    },
  },
});

export { twMerge as clsx, twMerge as default };
